export const fmtCount = (n) => (n == null ? "…" : n.toLocaleString("en-US"));
export const fmtMoney = (n) => `$${n.toFixed(2)}`;
